<template lang="pug">
.card
	.card-header.bg-success.text-white
		span.fa.fa-comments.mr-2
		| Comentarios
	.card-body
		textarea.form-control(rows="5", v-model="contrato.Comentarios", placeholder="Escribe aquí unos comentarios")
</template>

<script>
export default {
	props: ['contrato']
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/comentarios.vue